module.exports = __webpack_public_path__ + "img/donghaeng-logo.00229e7c.svg";